module.exports = __webpack_public_path__ + "img/s2_bg1.4ffbd02.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/dialog/UpgradeModal/images/s2_bg1.png
// module id = uvYI
// module chunks = 47